<div class="project-config panel">
  <h1>{{'PROJECT.Title' | translate}}</h1>
  <div class="row">
      <div class="col-sm-2"><label>{{'SYNCHRONIZATION.ProjectName' | translate}}:</label></div>
      <div class="col-sm-6"><span>{{currentProject?.Name}}</span></div>
  </div>
  <div class="row">
      <div class="col-sm-2"><label>{{'SYNCHRONIZATION.PrimaveraId' | translate}}:</label></div>
      <div class="col-sm-6"><span>{{currentProject?.ProjectId}}</span></div>
  </div>
  <div class="row">
      <div class="col-sm-2">
          <app-return-to-delta-report-btn [projectObjectId]="this.currentProject?.Id"></app-return-to-delta-report-btn>
      </div>
      <div class="project-completed col-sm-6">
          <label>{{'PROJECT.ProjectCompleted' | translate}}:</label>
          <p-toggleswitch [(ngModel)]="isProjectCompleted" (onChange)="statusCompletedDialogHandler($event)" [disabled]="projectInfo?.Completed"></p-toggleswitch>
      </div>
  </div>
  <div class="container">
      <div class="row" *ngIf="isAdmin">
          <div class="col-sm-8"></div>
          <div class="form-group col-sm-4"></div>
      </div>
      <div class="container-fluid">
          <div class="card">
              <p-tabs [hidden]="!currentProject" [(value)]="activeIndex">
                <p-tablist>
                  <p-tab [value]="0" [disabled]="!anyCrewAndCoRepsConfigured() || disablingTabs"
                    pTooltip="{{anyCrewAndCoRepsConfigured() ? '': 'Co-Reps and a Primary or Secondary crew required'}}">
                    <i class="pi pi-user-plus"></i> Crew Assignments
                  </p-tab>
                  <p-tab [value]="1" [disabled]="!coRepsConfigured(this.serverConfig) || disablingTabs"
                    pTooltip="{{coRepsConfigured(this.serverConfig) ? '': 'Configuration required'}}">
                    <i class="pi pi-user-plus"></i> Co-Reps Assignments
                  </p-tab>
                  <p-tab [value]="2" [disabled]="!coRepsConfigured(this.serverConfig) || disablingTabs"
                    pTooltip="{{coRepsConfigured(this.serverConfig) ? '': 'Configuration required'}}">
                    <i class="pi pi-users"></i> Crews
                  </p-tab>
                  <p-tab [value]="3" [disabled]="disablingTabs">
                    <i class="pi pi-cog"></i> Activity Code Types
                  </p-tab>
                  <p-tab [value]="4" [disabled]="disablingTabs">
                    <i class="pi pi-calendar-plus"></i> Shifts
                  </p-tab>
                  <p-tab [value]="5"
                    pTooltip="{{!this.projectTimezone ? 'Could not retrieve the project timezone': ''}}">
                    <i class="pi pi-calendar-plus"></i> Basic Project Information
                  </p-tab>
                </p-tablist>
                <p-tabpanels>
                <p-tabpanel [value]="0">
                <app-assignment-grid [assignments]="crewAssignments" [crews]="groupedCrews"
                  [isProjectCompleted]="projectInfo?.Completed" [projectID]="this.currentProject?.Id"></app-assignment-grid>
              </p-tabpanel>
                <p-tabpanel [value]="1">
                <app-assignment-grid [assignments]="coRepAssignments" [crews]="coRepCrews"
                [isProjectCompleted]="projectInfo?.Completed" [projectID]="this.currentProject?.Id">
                </app-assignment-grid>
              </p-tabpanel>
                  <p-tabpanel [value]="2">
                  <p-table #tt [value]="crews" showGridlines [paginator]="true" [rows]="10" [globalFilterFields]="['HierarchyPath', 'Description', 'typeName']">
                    <ng-template #caption>
                        <div class="grid">
                            <div class="col-6">
                                <input type="text" pInputText placeholder="{{'SHARED.Filter' | translate}}"
                                    (input)="tt.filterGlobal($event.target.value, 'contains')" class="form-control">
                            </div>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th scope="col" pSortableColumn="Name">{{'PROJECT.Name' | translate}} <p-sortIcon field="Name"></p-sortIcon>
                            </th>
                            <th scope="col" pSortableColumn="Description">{{'PROJECT.Description' | translate}} <p-sortIcon field="Description"></p-sortIcon>
                            </th>
                            <th scope="col" pSortableColumn="Type">{{'PROJECT.Type' | translate}} <p-sortIcon field="Type"></p-sortIcon>
                            </th>
                            <th scope="col" pSortableColumn="IsDeleted" style="width: 110;">{{'PROJECT.Disabled' | translate}}<p-sortIcon field="IsDeleted"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template #body let-crew>
                        <tr [ngClass]="{'highlight': crew.IsDeleted}">
                            <td>{{crew.HierarchyPath}}</td>
                            <td>{{crew.Description}}</td>
                            <td>{{crew.typeName}}</td>
                            <td>
                                <p-toggleswitch [(ngModel)]="crew.IsDeleted" (click)="updateCrew(crew)"
                                    [disabled]="projectInfo?.Completed"></p-toggleswitch>
                                <span *ngIf="crew.IsDeleted" pTooltip="This crew is disabled"></span>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>

                  </p-tabpanel>
                  <p-tabpanel [value]="3">
                    <h4>{{'PROJECT.PrimaveraCodeTypes' | translate}} {{currentProject ? currentProject.Name: ''}}</h4>
                    <div class="grid">
                      <div class="col-4">
                        <label>{{'PROJECT.PrimaryCrewCode' | translate}}:</label>
                        <p-select [(ngModel)]="config['Crew-1']" [options]="groupedActivityCode" [group]="true"
                        [style]="{'width':'100%'}" [disabled]="projectInfo?.Completed" [placeholder]="'SHARED.SelectOption' | translate"
                        [filter]="true" [filterFields]="['value.Name']" showClear="true">
                        <ng-template let-it #group>
                        <span class="list-sub-item">{{it.label}}</span><span *ngIf="it.value && it.value.Description">:
                          {{it.value.Name}}</span>
                      </ng-template>
                      </p-select>
                      </div>
                      <div class="col-4">
                        <label>{{'PROJECT.SupportingCrewCode' | translate}}:</label>
                        <p-select [(ngModel)]="config['Crew-2']" [options]="groupedActivityCode" [group]="true"
                          [style]="{'width':'100%'}" [disabled]="projectInfo?.Completed" [placeholder]="'SHARED.SelectOption' | translate"
                          [filter]="true" [filterFields]="['value.Name']" showClear="true">
                          <ng-template let-it #group>
                            <span class="list-sub-item">{{it.label}}</span><span *ngIf="it.value && it.value.Description">:
                              {{it.value.Name}}</span>
                          </ng-template>
                        </p-select>
                      </div>
                      <div class="col-4">
                        <label>{{'PROJECT.CompanyRepCode' | translate}}:</label>
                        <p-select [(ngModel)]="config['Co-Reps']" [options]="groupedActivityCode" [group]="true"
                          [style]="{'width':'100%'}" [disabled]="projectInfo?.Completed" [placeholder]="'SHARED.SelectOption' | translate"
                          [filter]="true" [filterFields]="['value.Name']" showClear="true">
                          <ng-template let-it #group>
                            <span class="list-sub-item">{{it.label}}</span><span *ngIf="it.value && it.value.Description">:
                              {{it.value.Name}}</span>
                          </ng-template>
                        </p-select>
                      </div>
                    </div>
                    <div class="grid">
                      <div class="col-4">
                        <label>{{'PROJECT.EWO' | translate}}:</label>
                        <p-select [(ngModel)]="config['PA Job Number']" [options]="groupedactivityCodeTypes" [group]="true"
                          [style]="{'width':'100%'}" [disabled]="projectInfo?.Completed" [placeholder]="'SHARED.SelectOption' | translate"
                          [filter]="true" [filterFields]="['value.Name']" showClear="true">
                          <ng-template let-it #group>
                            <span class="list-sub-item">{{it.label}}</span><span *ngIf="it.value && it.value.Description">:
                              {{it.value.Name}}</span>
                          </ng-template>
                        </p-select>
                      </div>
                      <div class="col-8">
                        <div class="btn-container">
                          <p-button class="btn-primary" label="{{'SHARED.Save' | translate}}" icon="pi pi-check" [loading]="loading" (onClick)="confirmSave()"
                            [disabled]="!isSaveCodeTypesEnabled() || projectInfo?.Completed"></p-button>
                        </div>
                      </div>
                    </div>
                  </p-tabpanel>
                  <p-tabpanel [value]="4">
                      <app-shift-grid [project]="currentProject" [shifts]="projectShifts"
                        [offsetHour]="projectPSREndtimeOffsetHour" [offsetMinute]="projectPSREndtimeOffsetMinute"
                        [isProjectCompleted]="projectInfo?.Completed" [projectLocation]="projectLocation"
                        [projectTimezone]="projectTimezone"></app-shift-grid>
                  </p-tabpanel>
                  <p-tabpanel [value]="5">
                    <h4>{{'PROJECT.ProjectInformation' | translate}}</h4>
                    <form [formGroup]="projectInfoForm">
                      <div class="grid">
                        <div class="col-4">
                          <label>{{'PROJECT.ProjectType' | translate}}:</label>
                          <p-select [required]="true" [options]="projectTypes" [style]="{'width':'100%'}"
                            [placeholder]="'SHARED.SelectOption' | translate" [disabled]="projectInfo?.Completed"
                            formControlName="projectTypes" (onChange)="setProject()">
                          </p-select>
                        </div>
                        <div class="col-4">
                          <label>{{'PROJECT.PrimarySchedulerName' | translate}}:</label>
                          <p-select  [placeholder]="'SHARED.SelectUser' | translate" showClear="true"
                            [options]="userList" [disabled]="projectInfo?.Completed" [filter]="true" [filterFields]="['fullName','Email']" (onChange)="addUser($event)"
                             [style]="{'width':'100%'}" [virtualScroll]="true" [virtualScrollItemSize]="38"
                            formControlName="schedulerName">
                            <ng-template #selectedItem let-it>
                              {{it?.FirstName}} {{it?.LastName}}
                            </ng-template>
                            <ng-template #item let-it>
                              <label>{{it?.FirstName}} {{it?.LastName}}</label><br>
                              <small>{{it?.Email}}</small>
                            </ng-template>
                          </p-select>
                        </div>
                        <div class="col-4">
                          <label>{{'PROJECT.ContactPreference' | translate}}:</label>
                          <p-select [options]="contactInformation" [style]="{'width':'100%'}"
                          [placeholder]="'SHARED.SelectOption' | translate" [disabled]="projectInfo?.Completed"
                          formControlName="contactInformation" showClear="true">
                          </p-select>
                        </div>
                      </div>
                      <div class="grid">
                        <div class="col-4">
                          <label>{{'PROJECT.ApproximateUpdateStart' | translate}}:</label>
                          <p-datepicker [required]="true" [showIcon]="true" [style]="{'width':'100%'}" [keepInvalid]="true"
                          [readonlyInput]="true" [disabled]="projectInfo?.Completed" [inputStyle]="{'width':'100%'}"
                          formControlName="startDate">
                          </p-datepicker>
                          <label
                            *ngIf=" (projectInfo?.StartDate && projectInfo?.FinishDate) && (projectInfo?.StartDate > projectInfo?.FinishDate)"
                            class="invalid">{{'PROJECT.CantBeHigher' | translate}}</label>
                        </div>
                        <div class="col-4">
                          <label>{{'PROJECT.FinishDate' | translate}}:</label>
                          <p-datepicker [showIcon]="true" [required]="true" [style]="{'width':'100%'}" formControlName="finishDate"
                          [readonlyInput]="true" [disabled]="projectInfo?.Completed" [inputStyle]="{'width':'100%'}">
                          </p-datepicker>
                        </div>
                        <div class="col-4">
                          <label>{{'PROJECT.UpdatePeriod' | translate}}:</label>
                          <p-select [options]="updatePeriod" [style]="{'width':'100%'}" [placeholder]="'SHARED.SelectOption' | translate"
                            [disabled]="projectInfo?.Completed" showClear="true"
                            formControlName="updatePeriod">
                          </p-select>
                        </div>
                        <div class="col-4" *ngIf="qtyEnableBool === 'true'">
                            <p-checkbox formControlName="QtyEnable" [binary]="true" inputId="ny" />
                            <label for="ny" class="ml-2">Planned Qty & Actual Qty</label>
                        </div>
                        <div class="col-4">
                            <p-checkbox formControlName="EmailNotificationEnabled" [binary]="true" inputId="emailNotification" />
                            <label for="emailNotification" class="ml-2">Enable Email Notification</label>
                        </div>
                      </div>
                      <div class="row" style="margin-bottom: 1em">
                        <div class="col-sm-8"><label style="color: red;">*Note: Basic project information is required to proceed with the next steps.</label></div>
                        <div class="col-sm-4">
                          <div class="btn-container">
                            <p-button class="btn-primary" label="{{'SHARED.Save' | translate}}" icon="pi pi-check"  (onClick)="saveProjectInfo()"
                              [disabled]="!isSaveProjectInfoEnabled()">
                            </p-button>
                        </div>
                        </div>
                      </div>
                    </form>
                  </p-tabpanel>
                </p-tabpanels>
              </p-tabs>
          </div>
      </div>
  </div>
</div>


<p-dialog header="Time Zone cannot be determined" [(visible)]="showNoTimeZoneModal" [modal]="true" [closable]="false">
  <p>
    {{ this.currentProject?.ProjectId }} <span [innerHTML]="'PROJECT.ZoneNotDetermined' | translate"></span>
  </p>
  <ng-template #footer>
    <button type="button" pButton icon="pi pi-home" (click)="this.navigateToHome()">{{'SHARED.Home' | translate}}</button>
  </ng-template>
</p-dialog>

<p-dialog header="Save changes" [(visible)]="displaySaveDialog" showEffect="fade" [modal]="true"
  [closable]="false">
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div class="ui-grid-row">
      <p [innerHTML]="'PROJECT.SaveChanges' | translate"></p>
    </div>
  </div>
  <ng-template #footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix">
      <button type="button" class="btn btn-primary" pButton icon="pi pi-times" (click)="setToCompleted(false)">{{'SHARED.No' | translate}}</button>
      <button type="button" class="btn btn-primary" pButton icon="pi pi-check" (click)="setToCompleted(true)">{{'SHARED.YesSave' | translate}}</button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog header="⚠️ Warning!!" [(visible)]="confirmChangeDialogVisible" showEffect="fade" [modal]="true" [closable]="false">
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div class="ui-grid-row ui-g-nopad">
      <div class="ui-grid-col-12 ui-text-center">
        <i class="pi pi-exclamation-triangle" style="font-size: 2em; color: orange;"></i>
        <p [innerHTML]="'PROJECT.Warning' | translate" style="margin-top: 1em;"></p>
      </div>
    </div>
  </div>
  <ng-template #footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix ui-g-nopad">

        <p-button [text]="true" [raised]="true" severity="danger" (click)="saveConfig(false)" label="{{'SHARED.No' | translate}}">
          <i class="pi pi-times" style="margin-right: 0.5em;"></i>
        </p-button>


        <p-button [text]="true" [raised]="true" severity="success" (click)="saveConfig(true)" label="{{'SHARED.Yes' | translate}}">
          <i class="pi pi-check" style="margin-right: 0.5em;"></i>
        </p-button>

    </div>
  </ng-template>
</p-dialog>


